SE.clsAudio = (function() {
    var player1, onplayhead, playerId, timeline, playhead, timelineWidth;
    //INIT
    function init() {
        initEvent();
        console.log("clsPopup - init");
    }

    function initEvent() {
        createUrl();
        // audioPlay();
        // ballSeek();
    }

    //FUNCTIONS

    function audioPlay() {
        var player = $("#player2")[0];

        initProgressBar();
        isPlaying = true;
    }

    function initProgressBar() {
        player1 = document.getElementById("player2");
        player1.addEventListener("timeupdate", timeCal);
        var playBtn = $(".play-pause");
        playBtn.click(function() {
            if (player1.paused === false) {
                player1.pause();
                isPlaying = false;
                $(this)
                    .removeClass("pause-black")
                    .addClass("play-black");
            } else {
                player1.play();
                isPlaying = true;
                $(this)
                    .removeClass("play-black")
                    .addClass("pause-black");
            }
        });
    }

    function timeCal() {
        var width = $("#timeline1").width();

        var progressbar = document.getElementById("seekObj1");
        progressbar.style.width =
            width * (player1.currentTime / player1.duration) + "px";
    }

    function timeCal() {
        var width = jQuery("#timeline1").width();

        var progressbar = document.getElementById("seekObj1");
        progressbar.style.width =
            width * (player1.currentTime / player1.duration) + "px";
    }

    function calculateTotalValue(length) {
        var minutes = Math.floor(length / 60);
        var seconds_int = length - minutes * 60;
        if (seconds_int < 10) {
            //console.info("here");
            seconds_int = "0" + seconds_int;
            //console.info(seconds_int);
        }
        var seconds_str = seconds_int.toString();
        var seconds = seconds_str.substr(0, 2);
        var time = minutes + ":" + seconds;
        //console.info(seconds_int)
        return time;
    }

    function calculateCurrentValue(currentTime) {
        var current_hour = parseInt(currentTime / 3600) % 24,
            current_minute = parseInt(currentTime / 60) % 60,
            current_seconds_long = currentTime % 60,
            current_seconds = current_seconds_long.toFixed(),
            current_time =
                (current_minute < 10 ? "0" + current_minute : current_minute) +
                ":" +
                (current_seconds < 10
                    ? "0" + current_seconds
                    : current_seconds);
        return current_time;
    }

    function ballSeek() {
        onplayhead = null;
        playerId = null;
        timeline = document.getElementById("timeline1");
        playhead = document.getElementById("seekObj1");
        timelineWidth = timeline.offsetWidth - playhead.offsetWidth;
        console.log(timeline.offsetWidth - playhead.offsetWidth);

        timeline.addEventListener("click", seek);
    }

    function seek(event) {
        var player = document.getElementById("player2");
        player.currentTime =
            player.duration * clickPercent(event, timeline, timelineWidth);
    }

    function clickPercent(e, timeline, timelineWidth) {
        return (event.clientX - getPosition(timeline)) / timelineWidth;

    }

    function getPosition(el) {
        return el.getBoundingClientRect().left;

    }
    // function seek() {
    //     $("#seekObj1").click(function() {});
    // }

    function createUrl() {


        var url_para = {
            url: 'https://open.spotify.com/track/6Im9k8u9iIzKMrmV7BWtlF?si=rdyA2LfpQtWyDac_krDHxg'
        };

        var track = spotify_parser(url_para.url);
        $(".audio-wrapper").append(
            // '<audio id="player2"><source src="' +
            //     url_para.url +
            //     '" type="audio/mp3"></audio>'

            '<iframe src="https://open.spotify.com/embed/track/'+ track +'" width="100%" height="80" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>'
        );
    }

    function spotify_parser(url){
        var regExp = /^.*((track\/))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[3].length==22)? match[3] : false;
    }

    //RETURN
    return {
        init: init
    };
})();
SE.clsAudio.init();
